// extracted by mini-css-extract-plugin
export default {"group":"Group_group__x3YMe","spacer":"Group_spacer__ynt-T","label":"Group_label__mcBDC"};